import React, { createContext, useContext, useState, useEffect } from 'react';
import API from '../api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem('clump_user');
    if (stored) setUser(JSON.parse(stored));
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    const res = await API.post('/api/auth/login', { email, password });
    localStorage.setItem('clump_token', res.data.token);
    localStorage.setItem('clump_user', JSON.stringify(res.data.user));
    setUser(res.data.user);
    return res.data.user;
  };

  const signup = async (email, password, slug, displayName, firstName, lastName, marketingOptIn) => {
    const res = await API.post('/api/auth/signup', { email, password, slug, display_name: displayName, first_name: firstName, last_name: lastName, marketing_opt_in: marketingOptIn });
    localStorage.setItem('clump_token', res.data.token);
    localStorage.setItem('clump_user', JSON.stringify(res.data.user));
    setUser(res.data.user);
    return res.data.user;
  };

  const logout = () => {
    localStorage.removeItem('clump_token');
    localStorage.removeItem('clump_user');
    localStorage.removeItem('clump_billing');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, signup, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
